import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProfileUpdateService {
  private _profileUpdated = signal<boolean>(false);
  userProfileUpdated = this._profileUpdated.asReadonly();

  setUserProfileUpdated(value: boolean) {
    this._profileUpdated.set(value);
  }
}